module.exports = __webpack_public_path__ + "img/band-light.03efe45c.svg";